"use client";

import { Typography, useModal } from "@tosize/ui";
import { CircleLink } from "~/components/Link";
import type { ProductAttribute } from "~/graphql/genql/magento";
import { useQuery } from "~/hooks/useQuery";

interface ProductAttributesProps {
	attribute: ProductAttribute;
}
export function ProductAttributes({ attribute }: ProductAttributesProps) {
	const dialog = useModal();
	const { createUrl } = useQuery();

	return (
		<>
			<div className="grid grid-cols-2 md:grid-cols-3">
				<Typography
					variant="paragraph-bold"
					component="span"
					className="flex items-center bg-white px-4 py-2"
				>
					{attribute.label}

					{attribute.hasDescription && (
						<CircleLink
							href={`${createUrl({ explanation: attribute.code })}#product-specifications`}
							title={attribute.label}
							onClick={dialog.toggle}
							className="ml-auto text-sm"
						/>
					)}
				</Typography>
				<Typography
					variant="paragraph"
					component="span"
					className="flex items-center justify-items-start px-4 py-2 md:col-span-2"
				>
					{attribute.value}
				</Typography>
			</div>
		</>
	);
}
